import { Box } from '@react-three/drei'

export default function ChairMesh({ width, height, depth, position, color, isSelected }) {
    // 座面（天板と同じ扱い）: 高さの10%（脚の上）
    const seatHeight = height * 0.1
    const seatY = position[1] + height / 2 - height * 0.45 - seatHeight / 2

    // 背もたれ: 高さの45%、幅100%（座面と同じ）、奥行きの10%（座面の上）
    const backHeight = height * 0.45
    const backWidth = width
    const backDepth = depth * 0.1
    const backY = position[1] + height / 2 - backHeight / 2
    const backZ = -depth / 2 + backDepth / 2

    // 脚: 4本の細い柱（高さ45%）
    const legWidth = width * 0.08
    const legDepth = depth * 0.08
    const legHeight = height * 0.45
    const legY = position[1] - height / 2 + legHeight / 2

    const legPositions = [
        [-width / 2 + legWidth / 2, legY, -depth / 2 + legDepth / 2], // 左手前
        [width / 2 - legWidth / 2, legY, -depth / 2 + legDepth / 2], // 右手前
        [-width / 2 + legWidth / 2, legY, depth / 2 - legDepth / 2], // 左奥
        [width / 2 - legWidth / 2, legY, depth / 2 - legDepth / 2], // 右奥
    ]

    return (
        <group>
            {/* 座面 */}
            <Box args={[width, seatHeight, depth]} position={[0, seatY, 0]}>
                <meshStandardMaterial
                    color={color}
                    metalness={0.3}
                    roughness={0.4}
                    opacity={isSelected ? 1 : 0.9}
                    transparent
                />
            </Box>

            {/* 背もたれ */}
            <Box args={[backWidth, backHeight, backDepth]} position={[0, backY, backZ]}>
                <meshStandardMaterial
                    color={color}
                    metalness={0.3}
                    roughness={0.4}
                    opacity={isSelected ? 1 : 0.9}
                    transparent
                />
            </Box>

            {/* 脚 */}
            {legPositions.map((legPos, index) => (
                <Box key={index} args={[legWidth, legHeight, legDepth]} position={legPos}>
                    <meshStandardMaterial
                        color={color}
                        metalness={0.3}
                        roughness={0.4}
                        opacity={isSelected ? 1 : 0.9}
                        transparent
                    />
                </Box>
            ))}

            {/* ワイヤーフレーム - 座面 */}
            <Box args={[width, seatHeight, depth]} position={[0, seatY, 0]}>
                <meshBasicMaterial
                    color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'}
                    wireframe
                    opacity={isSelected ? 0.6 : 0.3}
                    transparent
                />
            </Box>

            {/* ワイヤーフレーム - 背もたれ */}
            <Box args={[backWidth, backHeight, backDepth]} position={[0, backY, backZ]}>
                <meshBasicMaterial
                    color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'}
                    wireframe
                    opacity={isSelected ? 0.6 : 0.3}
                    transparent
                />
            </Box>

            {/* ワイヤーフレーム - 脚 */}
            {legPositions.map((legPos, index) => (
                <Box key={`wire-${index}`} args={[legWidth, legHeight, legDepth]} position={legPos}>
                    <meshBasicMaterial
                        color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'}
                        wireframe
                        opacity={isSelected ? 0.6 : 0.3}
                        transparent
                    />
                </Box>
            ))}

            {/* 選択時のハイライト */}
            {isSelected && (
                <Box args={[width, height, depth]} position={position}>
                    <meshBasicMaterial
                        color="#fbbf24"
                        wireframe
                        opacity={0.8}
                        transparent
                    />
                </Box>
            )}
        </group>
    )
}
